import { AppError } from "../../../app-store-error.types";
import { ReviewQuotesState, initialReviewQuotesState } from "./review-quotes/review-quotes.state";

// **************************************************************************
// CENTRAL SUPPORT STATE
// **************************************************************************
export interface CentralSupportState {
    reviewQuotes: ReviewQuotesState;
    error: AppError | null;
}

export const initialCentralSupportState: CentralSupportState = {
    reviewQuotes: initialReviewQuotesState,
    error: null,
};
